import React, { useEffect, useState } from "react";
import DynaModal from "../Modal/DynaModal";
import DynaInput from "../UI/DynaInput/DynaInput";
import "./ModalLearner.scss";
import _axios from "../../httpService";
import { toast } from "react-toastify";
import defaultImage from "../../Assets/Images/defualtImage.png";
import { useNavigate } from "react-router-dom";

const ModalLearner = ({ onClose, photo }) => {
    const [checked, setChecked] = useState("persian");
    const [checke, setChecke] = useState("everyBody");
    const [sendData, setSendData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [selectedRadio, setSelectedRadio] = useState(null);
    const navigateTo = useNavigate();

    const cardData = [
        { academiName: 'نام آموزشگاه', name: 'الناز مهاجر', ClassName: 'زبان سطح 2', code: 123456, day: 'سه شنبه ها', time: '16:00 الی 18:00', url: "", footer: 'www.sitename.ir' },
        // { academiNameEn: 'academy name', nameEn: 'Elnaz Mohajer', ClassNameEn: 'English, Level 2', codeEn: 123456, dayEn: 'Thursdays', timeEn: '16:00 Until 18:00', urlEn: "", footerEn: 'www.sitename.ir' }
    ]

    useEffect(() => {
        setSendData({
            alarmText: "",
            alarmType: "persian",
            alarmLearner: "everyBody",
            FooterText: "",
        });

        setSelectedRadio("everyBody");
    }, []);

    const [formValid, setFormValid] = useState({
        alarmText: true,
        FooterText: true,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSendData({
            ...sendData,
            [name]: value,
        });

        if (e.target.name === "alarmText") {
            setFormValid({ ...formValid, alarmText: true });
        }

        if (e.target.name === "FooterText") {
            setFormValid({ ...formValid, FooterText: true });
        }

        if (e.target.name === "alarmLearner") {
            setSelectedRadio(e.target.value);
        }
    };

    const modalDataHandle = () => {
        if (sendData.alarmText === "") {
            return setFormValid({ ...formValid, alarmText: false });
        }

        if (sendData.alarmType === "") {
            return setFormValid({ ...formValid, alarmType: false });
        }

        if (sendData.alarmLearner === "") {
            return setFormValid({ ...formValid, alarmLearner: false });
        }

        if (sendData.FooterText === "") {
            return setFormValid({ ...formValid, FooterText: false });
        }

        const myFormData = new FormData();
        for (const singleData in sendData) {
            myFormData.append(singleData, sendData[singleData]);
        }

        console.log("Data to be sent:", sendData); // Log the user input
        console.log("myFormData:", myFormData); // Log the FormData

        navigateTo("/CardLearner", { state: { cardData: cardData } });

        // _axios.post("",
        //     myFormData
        // ).then((response) => {
        //     if (response.data.status) {
        //         toast.success(response.data.message)
        //         setShowModal(false)

        //     } else {
        //         toast.error(response.data.message)
        //     }
        // })
    };

    const alarmTypeHandler = (e) => {
        setSendData({ ...sendData, alarmType: e.target.value });
        setChecked(e.target.value);
    };

    const alarmLearnerHandler = (e) => {
        setSendData({ ...sendData, alarmLearner: e.target.value });
        setChecke(e.target.value);
        setSelectedRadio(e.target.value);
    };

    let isChecked = (item) =>
        checked.includes(item) ? "checked-item" : "not-checked-item";

    let isChecke = (item) =>
        checke.includes(item) ? "checke-item" : "not-checke-item";

    const photoUrl = photo && photo.url ? photo.url : defaultImage;

    return (
        <DynaModal onClose={onClose} className={"Modal"}>
            <div className="header-modal">
                <div onClick={onClose}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
                            fill="#EB455F"
                        />
                        <path
                            d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
                            fill="#EB455F"
                        />
                        <path
                            d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                            fill="#EB455F"
                        />
                    </svg>
                </div>
            </div>

            <div className="content-modal">
                <div className="parentImageLearner">
                    <div className="imageLearner">
                        <img src={photoUrl} alt="" />
                    </div>
                </div>

                <div className="form-content">
                    <div className="radioLearner">
                        <div
                            className={`rowRadioLearner ${selectedRadio === "everyBody" ? "selected" : ""
                                }`}
                        >
                            <span className={isChecke(sendData.alarmLearner)}>همه</span>
                            <input
                                value={"everyBody"}
                                type="radio"
                                name="alarmLearner"
                                checked={selectedRadio === "everyBody"} // Set the checked attribute directly
                                onChange={(e) => alarmLearnerHandler(e)}
                            />
                        </div>
                        <div
                            className={`rowRadioLearner ${selectedRadio === "Learner" ? "selected" : ""
                                }`}
                        >
                            <span className={isChecke(sendData.alarmLearner)}>
                                زبان آموز خاص
                            </span>
                            <input
                                value={"Learner"}
                                type="radio"
                                name="alarmLearner"
                                checke={checke === "Learner" ? "checke" : ""}
                                onChange={(e) => alarmLearnerHandler(e)}
                            />
                        </div>
                        <div
                            className={`rowRadioLearner ${selectedRadio === "class" ? "selected" : ""
                                }`}
                        >
                            <span className={isChecke(sendData.alarmLearner)}>کلاس</span>
                            <input
                                value={"class"}
                                type="radio"
                                name="alarmLearner"
                                checke={checke === "class" ? "checke" : ""}
                                onChange={(e) => alarmLearnerHandler(e)}
                            />
                        </div>
                    </div>

                    <DynaInput
                        typeMode={"input"}
                        name="alarmText"
                        id="alarmTextId"
                        label="عنوان"
                        type="text"
                        style={{ width: "95%" }}
                        placeholder="کد کلاس را وارد کنید"
                        className={`solid-login-type ${formValid.alarmText ? "" : "solid-login-type-error"
                            }`}
                        onChange={handleInputChange}
                    />

                    <DynaInput
                        typeMode={"input"}
                        name="FooterText"
                        id="FooterTextId"
                        label="فوتر"
                        type="text"
                        style={{ width: "95%" }}
                        placeholder="کد کلاس را وارد کنید"
                        className={`solid-login-type ${formValid.FooterText ? "" : "solid-login-type-error"
                            }`}
                        onChange={handleInputChange}
                    />

                    <div className="current-list-alarm">
                        <div className="row-alarm-type">
                            <span className={isChecked(sendData.alarmType)}>فارسی</span>
                            <input
                                value={"persian"}
                                type="radio"
                                name="alarmType"
                                checked={checked === "persian" ? "checked" : ""}
                                onChange={(e) => alarmTypeHandler(e)}
                            />
                        </div>
                        <div className="row-alarm-type">
                            <span className={isChecked(sendData.alarmType)}>انگلیسی</span>
                            <input
                                value={"english"}
                                type="radio"
                                name="alarmType"
                                checked={checked === "english" ? "checked" : ""}
                                onChange={(e) => alarmTypeHandler(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="button-modal">
                <button className="accept-saden-modal" onClick={modalDataHandle}>
                    ثبت
                </button>
            </div>
        </DynaModal>
    );
};

export default ModalLearner;
